import { useEffect, useCallback } from 'react';
import { useAppDispatch } from 'store/hooks';
import * as actions from '../actions';
import * as selectors from './selectors';
const useConnectedAccount = () => {
    const cachedConnectedAccount = selectors.useConnectedAccount();
    const dispatch = useAppDispatch();
    const fetchConnectedAccount = useCallback(() => {
        dispatch(actions.getConnectedAccount());
    }, []);
    useEffect(() => {
        if (!cachedConnectedAccount) {
            fetchConnectedAccount(); // should be run only on mount
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return cachedConnectedAccount;
};
export default useConnectedAccount;
